module.exports = __webpack_public_path__ + "static/media/LogoCollector.320c20ff.png";